/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateClaimImageRequest = {
    sequence: number;
    documentRefId: string;
    type: CreateClaimImageRequest.type;
};
export namespace CreateClaimImageRequest {
    export enum type {
        DETAIL = 'DETAIL',
        MOBILE_LOCK = 'MOBILE_LOCK',
        SLIP = 'SLIP',
        REPAIRED = 'REPAIRED',
        OWNER_SHIP = 'OWNER_SHIP',
        OWNER_RECEIVE = 'OWNER_RECEIVE',
        RECEIVER_SHIP = 'RECEIVER_SHIP',
        RECEIVER_RECEIVE = 'RECEIVER_RECEIVE',
        RECEIVER_REJECT = 'RECEIVER_REJECT',
        OTHER = 'OTHER',
    }
}

